import React from 'react';
import { CheckIcon, FileTextIcon, PawPrintIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { socialProof } from '../data/content';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/gDYbFEoGXqkuvwCs84yAHh/ChatGPT_Image_16_sept_2026,_12_57_07_a.m..png';
const features = [{
  icon: FileTextIcon,
  label: 'PDF Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: PawPrintIcon,
  label: 'Cualquier raza y edad'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CheckIcon,
  label: 'Pago seguro'
}, {
  icon: CheckIcon,
  label: 'Mercado Pago'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-forest-900" data-id="element-107" data-mp="nczt16jsw3vm">
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, #F8F4E9 1px, transparent 0)',
      backgroundSize: '28px 28px'
    }} data-id="element-108" data-mp="nekqb3xi20x6" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center px-5 pb-8 pt-5 text-center sm:pb-12 sm:pt-9" data-id="element-109" data-mp="3j9ty8ric7ai4">
        <p className="inline-flex items-center gap-1.5 rounded-full bg-gold-400/15 px-3 py-1 text-[0.58rem] font-bold uppercase tracking-[0.14em] text-gold-300 ring-1 ring-inset ring-gold-400/30 sm:text-[0.7rem] sm:tracking-[0.18em]" data-id="element-110" data-mp="3o5j3nbh1flmc">
          <StarIcon className="h-2.5 w-2.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-111" data-mp="30hhp9lx6haz0" />
          {socialProof.lectores} lectores · 7 Tomos + 5 Bonos
        </p>

        <h1 className="mt-3 font-display text-[2.15rem] uppercase leading-[0.95] text-cream-50 sm:mt-4 sm:text-[3.4rem] lg:text-[4rem]" style={{
        fontWeight: 900
      }} data-id="element-112" data-mp="35au9zkyqkxmh">
          Pack Sin Culpa,
          <br data-id="element-113" data-mp="2hjf6hov84a9n" />
          <span className="text-gold-400" data-id="element-114" data-mp="2hincgih9yklh">Sin Destrozos</span>
        </h1>

        {/* Mockup principal: entre el título y el subtítulo */}
        <div className="relative mt-3 w-full sm:mt-4" data-id="element-115" data-mp="2lk8ra9ddd8yb">
          <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[70%] w-[65%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-forest-600/25 blur-3xl" data-id="element-116" data-mp="s2jnvz2aw4kk" />
          <img src={PRODUCT_IMAGE} alt="Pack Sin Culpa, Sin Destrozos: guía principal con 7 tomos y 5 bonos imprimibles" className="relative mx-auto w-[68%] max-w-[22rem] drop-shadow-2xl" width={1240} height={1200} sizes="(max-width: 640px) 68vw, 352px" loading="eager" decoding="async" {...{
          fetchpriority: 'high'
        }} data-id="element-117" data-mp="iboyiltrcouw" />
        </div>

        <p className="mt-3 max-w-xl font-display text-[0.95rem] uppercase leading-snug tracking-wide text-cream-50 sm:mt-4 sm:text-xl" style={{
        fontWeight: 600
      }} data-id="element-118" data-mp="110wq1scfxw5e">
          Método para que tu perro deje de sufrir cuando te vas
        </p>

        <p className="mt-2 max-w-lg text-[0.8rem] leading-relaxed text-cream-200 sm:text-[0.95rem]" data-id="element-119" data-mp="3hqagqilkozhv">
          Protocolo de 21 días, primeros auxilios anti-destrozos y planificación paso a paso.{' '}
          <strong className="font-semibold text-cream-50" data-id="element-120" data-mp="21bxwp0pekk98">Sin más culpa.</strong>
        </p>

        <ul className="mt-3 flex flex-wrap justify-center gap-x-3.5 gap-y-1 sm:mt-4 sm:gap-x-5" data-id="element-121" data-mp="268y69llgo553">
          {features.map(feature => <li key={feature.label} className="flex items-center gap-1.5 text-[0.7rem] font-medium text-cream-200 sm:text-sm" data-id="element-122" data-mp="2b2sm2dxy3zyw">
              <feature.icon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-123" data-mp="2kxkk1ivfwou7" />
              {feature.label}
            </li>)}
        </ul>

        <div className="mt-4 w-full sm:mt-6 sm:w-auto" data-id="element-124" data-mp="2tzbpqnpzcvo2">
          <CtaButton className="w-full" data-id="element-125" data-mp="2tysic0xyhpoa">💥 Quiero ayudar a mi mascota</CtaButton>
        </div>

        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3.5 gap-y-1 text-[0.65rem] font-medium text-cream-200/75 sm:mt-3.5 sm:text-xs" data-id="element-126" data-mp="uo0u224pouq4">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1" data-id="element-127" data-mp="49t29q7vsqqr">
              <item.icon className="h-3 w-3 text-gold-400" aria-hidden="true" data-id="element-128" data-mp="3vignm664gdyb" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </header>;
}